// Notifies client-side listeners (e.g. PermissionProvider) that the stored
// auth user changed, so they can re-read localStorage without a page refresh.
export const AUTH_CHANGE_EVENT = 'auth-change';

export function notifyAuthChange() {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}
